import { createStore } from "vuex";

import app from "./modules/app";
import auth from "./modules/auth";
import cart from "./modules/cart";
import collection from "./modules/collection";
import product from "./modules/product";
import search from "./modules/search";
import sustainability from "./modules/sustainability";
import addToBag from "./modules/add-to-bag";

export default createStore({
  modules: {
    app,
    auth,
    search,
    cart,
    collection,
    product,
    sustainability,
    "add-to-bag": addToBag,
  },
});
